import React from 'react';
import {Modal, View, TouchableOpacity, StyleSheet} from 'react-native';
import CCText from '@/Atoms/CCText';
import CCColors from '@/Utils/CCColors';
import {FontSizes} from '@/Utils/Dimensions';

interface MiniTournamentStartConfirmModalProps {
  visible: boolean;
  isSubmitting?: boolean;
  onJoinAndStart: () => void;
  onStartWithout: () => void;
  onClose: () => void;
}

export default function MiniTournamentStartConfirmModal({
  visible,
  isSubmitting,
  onJoinAndStart,
  onStartWithout,
  onClose,
}: MiniTournamentStartConfirmModalProps) {
  return (
    <Modal
      transparent
      visible={visible}
      animationType="fade"
      onRequestClose={onClose}>
      <View style={styles.backdrop}>
        <View style={styles.card}>
          <CCText fontSize={FontSizes[18]} fontWeight={600} style={styles.title}>
            Odd number of players
          </CCText>
          <CCText fontSize={FontSizes[14]} style={styles.body}>
            There's an odd number of players in this tournament, so one player
            would sit out each round with a bye. Join the tournament yourself to
            even out the pairings, or start anyway.
          </CCText>

          <TouchableOpacity
            onPress={onJoinAndStart}
            disabled={isSubmitting}
            style={[
              styles.actionBtn,
              styles.primaryBtn,
              isSubmitting && styles.btnDisabled,
            ]}>
            <CCText
              fontSize={FontSizes[14]}
              fontWeight={600}
              color={CCColors.White}>
              {isSubmitting ? 'Starting…' : 'Join & Start'}
            </CCText>
          </TouchableOpacity>

          <TouchableOpacity
            onPress={onStartWithout}
            disabled={isSubmitting}
            style={[styles.actionBtn, styles.secondaryBtn]}>
            <CCText
              fontSize={FontSizes[14]}
              fontWeight={600}
              color={CCColors.Orange}>
              Start without joining
            </CCText>
          </TouchableOpacity>

          <TouchableOpacity
            onPress={onClose}
            disabled={isSubmitting}
            style={[styles.actionBtn, styles.cancelBtn]}>
            <CCText
              fontSize={FontSizes[14]}
              fontWeight={500}
              color={CCColors.TextColor.Primary}>
              Cancel
            </CCText>
          </TouchableOpacity>
        </View>
      </View>
    </Modal>
  );
}

const styles = StyleSheet.create({
  backdrop: {
    flex: 1,
    backgroundColor: 'rgba(0,0,0,0.4)',
    justifyContent: 'center',
    alignItems: 'center',
  },
  card: {
    width: 380,
    backgroundColor: CCColors.White,
    borderRadius: 12,
    padding: 20,
  },
  title: {
    marginBottom: 10,
  },
  body: {
    marginBottom: 18,
    color: CCColors.TextColor.Primary,
    lineHeight: 20,
  },
  actionBtn: {
    paddingVertical: 11,
    borderRadius: 6,
    alignItems: 'center',
    marginTop: 8,
  },
  primaryBtn: {
    backgroundColor: CCColors.Orange,
  },
  secondaryBtn: {
    backgroundColor: 'transparent',
    borderWidth: 1,
    borderColor: CCColors.Orange,
  },
  cancelBtn: {
    backgroundColor: 'transparent',
  },
  btnDisabled: {
    backgroundColor: CCColors.OrangeDisabled,
  },
});
